import { ContentRequest } from '@/models/ContentRequest';
import Item, { ItemPutRequest, ItemRequest } from '@/models/Item';
import { LinkMetadata } from '@/models/LinkMetadata';
import { UpdateContentData } from '@/models/UpdateContentData';
import { ViewType } from '@/models/ViewType';
import { AxiosError } from 'axios';
import { action } from 'typesafe-actions';
import { ContentStudentView } from '../content/types';
import { ContentStudentViewRequest, ItemTypes, Itens } from './types';

export const getItemRequest = (contentId: number, refreshOnlyPath: boolean = false) =>
    action(ItemTypes.GET_ITEM_REQUEST, { contentId, refreshOnlyPath });
export const getItemSuccess = (data: Item) => action(ItemTypes.GET_ITEM_SUCCESS, data);
export const getItemPathSuccess = (data: string) => action(ItemTypes.GET_ITEM_PATH_SUCCESS, data);
export const getItemFailure = (error: AxiosError) => action(ItemTypes.GET_ITEM_FAILURE, error);

export const getItensRequest = (data: ItemRequest) => action(ItemTypes.GET_ITEMS_REQUEST, data);
export const getItensSuccess = (data: Itens, total: number) => action(ItemTypes.GET_ITEMS_SUCCESS, { data, total });
export const getItensFailure = (error: AxiosError) => action(ItemTypes.GET_ITEMS_FAILURE, error);
export const getItensClear = () => action(ItemTypes.GET_ITEMS_CLEAR);

export const postItemRequest = (data: { item: Item; willPublish: boolean }) => action(ItemTypes.POST_ITEM_REQUEST, data);
export const postItemSuccess = (data: Item) => action(ItemTypes.POST_ITEM_SUCCESS, data);
export const postItemFailure = (error: AxiosError) => action(ItemTypes.POST_ITEM_FAILURE, error);
export const postItemClear = () => action(ItemTypes.POST_ITEM_CLEAR);

export const putItemRequest = (data: ItemPutRequest) => action(ItemTypes.PUT_ITEM_REQUEST, data);
export const putItemSuccess = () => action(ItemTypes.PUT_ITEM_SUCCESS);
export const putItemFailure = (error: AxiosError) => action(ItemTypes.PUT_ITEM_FAILURE, error);
export const putItemClear = () => action(ItemTypes.PUT_ITEM_CLEAR);

export const deleteItemRequest = (data: number) => action(ItemTypes.DELETE_ITEM_REQUEST, data);
export const deleteItemSuccess = (data: number) => action(ItemTypes.DELETE_ITEM_SUCCESS, data);
export const deleteItemFailure = (error: AxiosError) => action(ItemTypes.DELETE_ITEM_FAILURE, error);
export const deleteItemClear = () => action(ItemTypes.DELETE_ITEM_CLEAR);

export const publishItemRequest = (data: { id: number; status: string | undefined }) => action(ItemTypes.PUBLISH_ITEM_REQUEST, data);
export const publishItemSuccess = (data: number) => action(ItemTypes.PUBLISH_ITEM_SUCCESS, data);
export const publishItemFailure = (error: AxiosError) => action(ItemTypes.PUBLISH_ITEM_FAILURE, error);
export const publishItemClear = () => action(ItemTypes.PUBLISH_ITEM_CLEAR);

export const archiveItemRequest = (data: number) => action(ItemTypes.ARCHIVE_ITEM_REQUEST, data);
export const archiveItemSuccess = (data: number) => action(ItemTypes.ARCHIVE_ITEM_SUCCESS, data);
export const archiveItemFailure = (error: AxiosError) => action(ItemTypes.ARCHIVE_ITEM_FAILURE, error);
export const archiveItemClear = () => action(ItemTypes.ARCHIVE_ITEM_CLEAR);

export const getContentListRequest = (data: ContentRequest) => action(ItemTypes.GET_CONTENT_LIST_REQUEST, data);
export const getContentListFailure = () => action(ItemTypes.GET_CONTENT_LIST_FAILURE);
export const contentsLastPublishedSuccess = (data: Item[], total: number) => action(ItemTypes.LAST_PUBLISHED_SUCCESS, { data, total });
export const contentMostAccessedSuccess = (data: Item[], total: number) => action(ItemTypes.MOST_ACCESSED_SUCCESS, { data, total });
export const contentInProgressSuccess = (data: Item[], total: number) => action(ItemTypes.IN_PROGRESS_SUCCESS, { data, total });
export const contentCompletedSuccess = (data: Item[], total: number) => action(ItemTypes.COMPLETED_SUCCESS, { data, total });
export const contentTopRatedSuccess = (data: Item[], total: number) => action(ItemTypes.TOP_RATED_SUCCESS, { data, total });
export const contentCategorizedSuccess = (data: Item[], total: number, categoryId?: number) =>
    action(ItemTypes.CATEGORIZED_SUCCESS, { data, total, categoryId });
export const contentFavoriteSuccess = (data: Item[], total: number) => action(ItemTypes.FAVORITES_SUCCESS, { data, total });
export const contentForYouSuccess = (data: Item[], total: number) => action(ItemTypes.FOR_YOU_SUCCESS, { data, total });

export const contentLikeYouSuccess = (data: Item[], total: number) => action(ItemTypes.LIKE_YOU_SUCCESS, { data, total });
export const contentsSearchedSuccess = (data: Item[], total: number) => action(ItemTypes.SEARCHED_SUCCESS, { data, total });
export const contentsSuggestedSuccess = (data: Item[], total: number) => action(ItemTypes.SUGGESTED_SUCCESS, { data, total });
export const contentsEssentialsSuccess = (data: Item[], total: number) => action(ItemTypes.ESSENTIALS_SUCCESS, { data, total });

export const clearContentList = (data: ViewType) => action(ItemTypes.CLEAR_CONTENT_LIST, data);

export const toggleItemVisibilityRequest = (data: number) => action(ItemTypes.TOGGLE_ITEM_VISIBILITY_REQUEST, data);
export const toggleItemVisibilitySuccess = (data: number) => action(ItemTypes.TOGGLE_ITEM_VISIBILITY_SUCCESS, data);
export const toggleItemVisibilityFailure = () => action(ItemTypes.TOGGLE_ITEM_VISIBILITY_FAILURE);
export const toggleItemVisibilityClear = () => action(ItemTypes.TOGGLE_ITEM_VISIBILITY_CLEAR);

export const contentsClear = () => action(ItemTypes.CONTENTS_CLEAR);
export const getContentRequest = (data: ContentStudentViewRequest) => action(ItemTypes.GET_CONTENT_REQUEST, data);
export const getContentSuccess = (data: Item) => action(ItemTypes.GET_CONTENT_SUCCESS, data);
export const getContentFailure = () => action(ItemTypes.GET_CONTENT_FAILURE);
export const clearContent = () => action(ItemTypes.CLEAR_CONTENT);
export const setCurrentContent = (data: Item) => action(ItemTypes.SET_CURRENT_CONTENT, data);
export const contentsSearchedClear = () => action(ItemTypes.CONTENTS_SEARCHED_CLEAR);

export const startContentRequest = (startContentData: ContentRequest) => action(ItemTypes.START_CONTENT_REQUEST, startContentData);
export const startContentSuccess = (contentId: number) => action(ItemTypes.START_CONTENT_SUCCESS, contentId);
export const startContentFailure = () => action(ItemTypes.START_CONTENT_FAILURE);

export const finishContentRequest = (finishContentData: ContentRequest) => action(ItemTypes.FINISH_CONTENT_REQUEST, finishContentData);
export const finishContentSuccess = (contentId: number) => action(ItemTypes.FINISH_CONTENT_SUCCESS, contentId);
export const finishContentFailure = () => action(ItemTypes.FINISH_CONTENT_FAILURE);
export const clearCurrentContentStudentViewFromListInProgress = (contentId: number) =>
    action(ItemTypes.CLEAR_CURRENT_CONTENT_STUDENT_VIEW_FROM_LIST_IN_PROGRESS, contentId);
export const addContentListByCategory = (categoryId: number) => action(ItemTypes.ADD_LIST_BY_CATEGORY, { categoryId });
export const updateContentStudentViewRequest = (updateContentData: UpdateContentData) =>
    action(ItemTypes.UPDATE_CONTENT_STUDENT_VIEW_REQUEST, updateContentData);
export const updateContentStudentViewSuccess = (contentStudentView: ContentStudentView) =>
    action(ItemTypes.UPDATE_CONTENT_STUDENT_VIEW_SUCCESS, contentStudentView);
export const updateContentStudentViewFailure = () => action(ItemTypes.UPDATE_CONTENT_STUDENT_VIEW_FAILURE);
export const removeContentFromList = (contentId: number, viewType: ViewType) => action(ItemTypes.REMOVE_CONTENT_FROM_LIST, { contentId, viewType });

export const setContentLinkMetadataRequest = (url: string) => action(ItemTypes.SET_CONTENT_LINK_METADATA_REQUEST, url);
export const setContentLinkMetadataSuccess = (data: LinkMetadata) => action(ItemTypes.SET_CONTENT_LINK_METADATA_SUCCESS, data);
export const setContentLinkMetadataFailure = () => action(ItemTypes.SET_CONTENT_LINK_METADATA_FAILURE);

export const contentTrainingsSuccess = (data: Item[], total: number) => action(ItemTypes.TRAININGS_SUCCESS, { data, total });
export const contentTrainingsClear = () => action(ItemTypes.TRAININGS_CLEAR);

export const contentsCompletedClear = () => action(ItemTypes.CONTENTS_COMPLETED_CLEAR);

export const increaseTotalSuggested = () => action(ItemTypes.INCREASE_TOTAL_SUGGESTED);
export const decreaseTotalSuggested = () => action(ItemTypes.DECREASE_TOTAL_SUGGESTED);

export const refreshItem = () => action(ItemTypes.REFRESH_ITEM);
